import { dateFormat, DateTimeFormatter } from '../../common/formatter/DateTimeFormatter';
import { ClassificationType, FeatureType } from '../../generated/ApiClient';

export const ClassificationTypeEntries = [
  {
    key: 'deal',
    value: ClassificationType.Deal,
  },
  {
    key: 'customer',
    value: ClassificationType.Customer,
  },
  {
    key: 'financingcalculation',
    value: ClassificationType.FinancingCalculation,
  },
  {
    key: 'model',
    value: ClassificationType.Model,
  },
  {
    key: 'trademark',
    value: ClassificationType.Trademark,
  },
  {
    key: 'specialOffer',
    value: ClassificationType.SpecialOffer,
  },
  {
    key: 'condition',
    value: ClassificationType.Condition,
  },
] as const;

export const getEntryByKey = (key: string) => {
  return ClassificationTypeEntries.find(
    (entry) => entry.key.toLocaleLowerCase() === key.toLowerCase()
  );
};

export const getEntryByEnum = (enumValue: ClassificationType) => {
  return ClassificationTypeEntries.find((entry) => entry.value === enumValue);
};

export const formatFeatureValue = (type: FeatureType, value: any): string => {
  if (value === null || value === undefined) {
    return '';
  }

  switch (type) {
    case FeatureType.Boolean:
      return value ? 'Ja' : 'Nein';

    case FeatureType.Number:
      if (typeof value === 'number') {
        return value.toString();
      }
      if (typeof value === 'string' && !isNaN(Number(value))) {
        return Number(value).toString();
      }
      return value.toString();

    case FeatureType.Date:
      if (value instanceof Date) {
        return DateTimeFormatter.format(value, { format: dateFormat });
      }
      if (typeof value === 'string') {
        const parsedDate = DateTimeFormatter.parse(value, { format: dateFormat });
        if (parsedDate) {
          return DateTimeFormatter.format(parsedDate, { format: dateFormat });
        }
        const isoDate = new Date(value);
        if (!isNaN(isoDate.getTime())) {
          return DateTimeFormatter.format(isoDate, { format: dateFormat });
        }
      }
      return value.toString();

    case FeatureType.Text:
    case FeatureType.Reference:
    default:
      return value.toString();
  }
};
